export default {
  name: 'SortSelectBtn',
  props: {
    btnConfig: Object
  },
  computed: {
    BtnClassList() {
      return [
        'sort-select-btn',
        this.btnConfig.isCur ? 'sort-select-btn_current' : '',
        this.btnConfig.isSelected ? 'sort-select-btn_selected' : ''
      ];
    },
    imageStyleObject() {
      return {
        backgroundImage: `url(${this.btnConfig.imageUrl || ''})`
      };
    }
  }
};
